import { useTabStore } from '@/stores/tabStore';
import { browserStorage } from '@/utils/browserStorage';
import { clearAllFormDrafts } from '@/utils/formDraft';
import { queryClient } from './queryClient';

const resetListeners = new Set<() => void>();
let revision = 0;

export function sessionRevision() {
  return revision;
}

export function onSessionReset(listener: () => void) {
  resetListeners.add(listener);
  return () => resetListeners.delete(listener);
}

/** Every identity boundary discards data belonging to the previous session. */
export function resetSession() {
  revision += 1;
  browserStorage.removeItem('token');
  queryClient.clear();
  useTabStore.getState().resetTabs();
  clearAllFormDrafts();
  for (const listener of resetListeners) listener();
}
